module.exports = __webpack_public_path__ + "img/grad_headshot.97514706.jpg";